import { WorkstationModePath } from "~/redux/reducers/workstations";

const pathModeMap: Record<string, WorkstationModePath> = {
  "/autostore-putaway": "induction",
  "/autostore-putaway-v2": "induction",
  "/autostore-pick": "picking",
  "/autostore-cyclecount": "cycle-count",
  "/autostore-cyclecountv2": "cycle-count",
  "/manual-inventory": "problem-solving",
  "/autostore-inventory": "problem-solving",
  "/autostore-inventory-holds": "problem-solving",
  "/bin-maintenance": "maintenance",
  "/workstation-bin-maintenance": "maintenance"
};

// this function is used to determine which mode to send to warehouse when the user navigates to a different page
export function convertRoutePathToWorkstationModePath(
  pathname: string
): WorkstationModePath | null {
  // Exact match
  if (pathname in pathModeMap) {
    return pathModeMap[pathname];
  }

  // Prefix match fallback
  for (const [prefix, mode] of Object.entries(pathModeMap)) {
    if (pathname.startsWith(prefix)) {
      return mode;
    }
  }
  return "standby";
}

export function normalizeWorkstationMode(
  mode: string | null | undefined
): WorkstationModePath | undefined {
  if (!mode) return undefined;
  switch (mode.trim().toLowerCase()) {
    case "problem solving":
      return "problem-solving";
    case "cycle count":
      return "cycle-count";
    case "induction":
      return "induction";
    case "picking":
      return "picking";
    case "maintenance":
      return "maintenance";
    case "standby":
      return "standby";
    default:
      return undefined;
  }
}

export function getWorkstationModeDisplayName(
  modeRaw: string | null | undefined
): string {
  const mode = normalizeWorkstationMode(modeRaw);
  switch (mode) {
    case "problem-solving":
    case "cycle-count":
      return "Quality Control";
    case "induction":
      return "Induction";
    case "picking":
      return "Picking";
    case "maintenance":
      return "Maintenance";
    case "standby":
      return "Standby";
    default:
      return "";
  }
}
